import React, {useEffect} from 'react'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {useLocation} from 'react-router-dom'

import {OnboardingStep, IOnboardingStore} from '@/stores/onboarding/models/onboarding'
import {ONBOARDING_STORE_SYMBOLS} from '@/stores/onboarding/symbols'
import {getRouterStore} from '@/router/utils'
import {ROUTES} from '@/router/routes'

import ApplicationSteps from './ApplicationSteps'

const ApplicationStepsContainer: React.FC = observer(() => {
    const onboardingStore = useInjection<IOnboardingStore>(ONBOARDING_STORE_SYMBOLS.OnboardingStore)
    const location = useLocation()

    const stepToRouteMap = {
        [OnboardingStep.START]: ROUTES.onboarding.base,
        [OnboardingStep.COMPANY_DETAILS]: ROUTES.onboarding.companyDetails,
        [OnboardingStep.COMPANY_CONTACTS]: ROUTES.onboarding.companyContacts,
        [OnboardingStep.OWNERS_DIRECTORS]: ROUTES.onboarding.ownersDirectors,
        [OnboardingStep.BANK_DETAILS]: ROUTES.onboarding.bankDetails,
        [OnboardingStep.OUTLETS_INFORMATION]: ROUTES.onboarding.outletsInformation,
        [OnboardingStep.REVIEW_SUBMIT]: ROUTES.onboarding.reviewSubmit,
        [OnboardingStep.APPLICATION_PROGRESS]: ROUTES.onboarding.applicationProgress
    }

    useEffect(() => {
        const currentPath = location.pathname

        Object.entries(stepToRouteMap).forEach(([stepKey, route]) => {
            if (currentPath === route) {
                const step = parseInt(stepKey) as OnboardingStep
                if (onboardingStore.currentStep !== step) {
                    onboardingStore.goToStep(step)
                }
            }
        })
    }, [location.pathname, onboardingStore, onboardingStore.isNavigatingFromValidation])

    const handleStepChange = (key: string) => {
        let targetStep: OnboardingStep | undefined

        if (key === 'company-details') {
            targetStep = OnboardingStep.COMPANY_DETAILS
        } else if (key === 'company-contacts') {
            targetStep = OnboardingStep.COMPANY_CONTACTS
        } else if (key === 'owners-directors') {
            targetStep = OnboardingStep.OWNERS_DIRECTORS
        } else if (key === 'bank-details') {
            targetStep = OnboardingStep.BANK_DETAILS
        } else if (key === 'outlets-information') {
            targetStep = OnboardingStep.OUTLETS_INFORMATION
        } else if (key === 'review-submit') {
            targetStep = OnboardingStep.REVIEW_SUBMIT
        } else if (key === 'application-progress') {
            targetStep = OnboardingStep.APPLICATION_PROGRESS
        }

        if (targetStep) {
            onboardingStore.goToStep(targetStep)

            const route = stepToRouteMap[targetStep]
            if (route) {
                getRouterStore().push(route)
            }
        }
    }

    return <ApplicationSteps onStepChange={handleStepChange} />
})

export default ApplicationStepsContainer
